/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_DoneInputs */

const en_us2_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pt_br2_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir`)
};

const es_419_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const pt_pt2_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir`)
};

const fr_fr2_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const de_de2_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

const it_it2_body_measures_done = /** @type {(inputs: Body_Measures_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Body_Measures_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_done = /** @type {((inputs?: Body_Measures_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_done(inputs)
	if (locale === "es-419") return es_419_body_measures_done(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_done(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_done(inputs)
	if (locale === "de-DE") return de_de2_body_measures_done(inputs)
	if (locale === "it-IT") return it_it2_body_measures_done(inputs)
	return en_us2_body_measures_done(inputs)
});
export { body_measures_done as "body-measures.done" }